import { API_RELATIONSHIPS } from "@/constants";

// Important: export a factory function (not a singleton object).
// Vuex mutates the provided root state object when installing modules. If we reuse the same
// object across store recreations (HMR/session restore), Vuex will warn that module state
// fields (e.g. "university") are being overridden.
const createState = () => {
  return {
    formioToken: "",
    currentUser: null,
    enrollmentToken: "",
    userData: {},
    studentApplications: [],
    studentFormioSubmissions: [],
    currentApplicationSubmissions: {},
    onBoardingFormioSubmissions: [],
    selectedProgramId: "",
    program: {},
    isInternship: false,
    universityName: "",
    universityCity: "",
    universityImageUrl: "",
    universityWebsiteUrl: "",
    programSelected: false,
    billingRules: {},
    payments: [],
    term: "",
    enrollmentApplications: [],
    sessionExpired: false,
    redirectPath: "",
    previousApplication: {
      previousApplicationId: "",
      session: "",
      paidFee: false,
      applicationFee: 0,
      transactionId: "",
      finished: false,
      submissionId: "",
    },
    currentApplicationId: "",
    applicationPaid: false,
    customer_id: "",
    uiVersion: "",
    completedSections: {
      onboarding1: false,
      payment: false, // confirmation payment
      onboarding2: false,
      otherPayments: false,
    },
    onboardingStep1Forms: {},
    onboardingStep2Forms: {},
    currentGpa: 0,
    directProgramData: {},
    appliedAgreement: {},
    institutionPaysApplicationFee: false,
    institutionPaysConfirmationPayment: false,
    institutionPaysAcademicFee: false,
    institutionPaysHousingFee: false,
    financialAid: "",
    certifyFAFSA: false,
    featureFlags: {},
    addressInfo: {},
    newAccountAndApplication: false, // Only for V3, used to show the 1st step one time
    profileData: {}, // Since V3: User has a profile from the profile-service repo
    profileSelectedObjects: {
      loaded: false,
      citizenship: null,
      citizenship2: null,
      school: null,
      majors: [],
      minors: [],
      currentCountry: null,
      permanentCountry: null,
      billingCountry: null,
    },
    stepsInV3: [
      { completed: false, data: null, step: "AccountCreation" },
      { completed: false, data: null, step: "AboutYou" },
      { completed: false, data: null, step: "LearnerInfo" },
      { completed: false, data: null, step: "Review" },
      { completed: false, data: null, step: "GroupVisa" },
      { completed: false, data: null, step: "Checkout" },
      { completed: false, data: null, step: "NextSteps" },
    ],
    programSessionDataV3: {}, // stores data of session
    redirectSessionData: {
      programId: null,
      sessionId: null,
    },
    currentAPIRelationship: API_RELATIONSHIPS.DEFAULT, // exclusive to advisors
    anonToken: undefined, // Okta anonymous access token for unauthenticated users (e.g. AI chat widget)
  };
};

export default createState;
